import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    actions: {
        loadOrders({}, options) {
            return Vue.$graphql
                .query({
                    query: gql`
                        query orders($page: Int!, $limit: Int!) {
                            orders(page: $page, limit: $limit) {
                                data {
                                    id
                                    OrderAddresses
                                    success_date
                                    price_total
                                    ShippingPrices {
                                        price
                                        company_department_id
                                    }
                                    OrderItems {
                                        id
                                        Options
                                        quantity
                                        price_original
                                        price_vat
                                        price_total
                                        discount
                                        product_catalog_item_id
                                        master_catalog_item_id
                                        is_pickup
                                        fees {
                                            id
                                            name
                                            value
                                            is_percent
                                            per_product
                                        }
                                    }
                                    Fees {
                                        type
                                        value
                                    }
                                }
                                total
                                limit
                                page
                            }
                        }
                    `,
                    variables: options,
                })
                .then(r => r.data.orders);
        },
    },
};